<template lang="html">
  <div id="data-list-list-view" class="data-list-container">
    <vx-card title="Guarantor List">
      <template slot="actions">
        <vx-input-group class="mb-base">
          <vs-input class="w-full" placeholder="Enter Mobile No or Nid No" @keypress="onlyNumber"  v-model="searchParam" />
          <template slot="append">
            <div class="append-text btn-addon">
              <vs-button color="rgb(0 121 193)"  icon-pack="feather" icon="icon-search" @click="searchGuarantor(searchParam)"></vs-button>
            </div>
          </template>
        </vx-input-group>
      </template>
      <!--      <vs-table stripe
                      :sst="true"
                      @search="handleSearch"
                      @change-page="handleChangePage"
                      @sort="handleSort"
                      v-model="selected"
                      :total="meta.total"
                      pagination
                      :max-items="meta.per_page"
                      search
                      :data="applicantList">-->
      <vs-table stripe
                :sst="true"
                @change-page="handleChangePage"
                v-model="selected"
                :total="meta.total"
                pagination
                :max-items="meta.per_page"
                :data="gaurantorList">
        <!--<template slot="header">
          <h3>
            All Guarantor
          </h3>
        </template>-->
        <template slot="thead">
          <vs-th sort-key="name">
            Agreement ID
          </vs-th>
          <vs-th sort-key="name">
            Name
          </vs-th>
          <vs-th sort-key="phone">
            Mobile
          </vs-th>
          <vs-th sort-key="nid">
            Nid no
          </vs-th>

          <vs-th sort-key="id">
            Action
          </vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].purchase_id">
              {{paddingId(data[indextr].purchase_id)}}
            </vs-td>

            <vs-td :data="data[indextr].name">
              {{data[indextr].name}}
            </vs-td>

            <vs-td :data="data[indextr].ekyc.phone">
              {{data[indextr].ekyc.phone}}
              <vs-button @click="showPassresetPopup(data[indextr].user_id)"
                         placeholder="Enter new mobile number" color="success" type="flat" size="small">Reset Password
              </vs-button>
            </vs-td>

            <vs-td :data="data[indextr].ekyc.nid">
              {{data[indextr].ekyc.nid}}
            </vs-td>


            <vs-td class="whitespace-no-wrap flex justify-between">
              <!--<feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                            class="clickable"/>
              <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current"
                            class="ml-2 clickable"/>-->
              <feather-icon icon="EyeIcon" @click="guarantorDetal(data[indextr].id)"
                            svgClasses="w-5 h-5 hover:text-success stroke-current"
                            class="ml-2 clickable"/>

            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
    <template lang="html">
      <div class="centerx">
        <vs-popup class="holamundo" title="Password Reset!" :active.sync="popupActivForPassReset">
          <vx-card>
            <div class="vx-col sm:w-1/1 w-full mb-2">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/1 w-full mt-4">
                  <h5>Are you want to reset password for this guarantor?</h5>
                </div>
                <div class="vx-col sm:w-1/1 w-full">
                  <h4>Password reset with: 123456</h4>
                  <br>
                  <vs-button color="primary" @click="resetPassword(passResetId)">Reset</vs-button>

                </div>
              </div>
            </div>
          </vx-card>
        </vs-popup>
      </div>
    </template>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex'
  import axios from "../axios";

  export default {
    data() {
      return {
        selectedPgae: 1,
        selected: [],
        searchParam:'',
        popupActivForPassReset: false,
        passResetId: '',
      }
    },
    computed: {
      ...mapGetters(['gaurantorList', 'meta'])
    },
    mounted() {
      this.$store.dispatch('getGaurantorList', `?page=${this.selectedPgae}`);
      console.log("ff", this.gaurantorList);
    },
    watch: {
      searchParam(value){
        if(value.length < 1){
          this.$store.dispatch('getGaurantorList', `?page=${this.selectedPgae}`);
        }
      }
    },
    methods: {
      onlyNumber ($event) {
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which)
        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
          $event.preventDefault()
        }
      },
      handleChangePage(page) {
        this.selectedPgae = page;
        console.log("paramdddd", this.searchParam)
        if(this.searchParam){
          console.log("param")
          const param = `?page=${this.selectedPgae}&search=${this.searchParam}`;
          this.$store.dispatch('getGaurantorList', param);
        }else {
          console.log("empty param")
          this.$store.dispatch('getGaurantorList', `?page=${this.selectedPgae}`);
        }
      },
      guarantorDetal(id){
        this.$router.push('/guarantor-details/' + id).catch(() => { })
      },
      searchGuarantor(data){
        const param = `?page=${this.selectedPgae}&search=${data}`;
        this.$store.dispatch('getGaurantorList', param);
      },
      showPassresetPopup(user_id) {
        this.popupActivForPassReset = true;
        this.passResetId = user_id;
      },
      async resetPassword(user_id) {
        axios.post(`https://ho.butterflygroupbd.com/showroom-backend/api/passwordreset/${user_id}/reset-password`).then((response)=>{
          console.log("Password = ", response.data);
          this.popupActivForPassReset = false;
          if(response.status === 200){
            this.$vs.notify({
              title: 'Success',
              text: 'Successfully Reset Password with 123456.',
              color: 'success',
              position: 'top-right'
            });
          }
        });
      },
      paddingId(id){
        if(id){
          if(id.toString().length === 1){return 'A000000000'+id;}
          else if(id.toString().length === 2){return 'A00000000'+id;}
          else if(id.toString().length === 3){return 'A0000000'+id;}
          else if(id.toString().length === 4){return 'A000000'+id;}
          else if(id.toString().length === 5){return 'A00000'+id;}
          else if(id.toString().length === 6){return 'A0000'+id;}
          else if(id.toString().length === 7){return 'A000'+id;}
          else if(id.toString().length === 8){return 'A00'+id;}
          else if(id.toString().length === 9){return 'A'+id;}
          else if(id.toString().length === 10){return id;}
        }
      }
    }
  }


</script>
